/* GS PDP Gallery - 1 Hauptbild + Thumbnails + Video getrennt (wie Kolostrum).
   Standalone, kein GSAP noetig. Laedt sofort auf Produktseiten. */
(function () {
  'use strict';
  function isVideoSlide(slide) {
    return !!slide.querySelector('video, deferred-media, iframe, [data-media-type="video"], [data-media-type="external_video"]');
  }
  function initGalleryCarousel() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.gsMounted === 'true') return;
      var allSlides = Array.from(gallery.querySelectorAll('slideshow-slide'));
      if (allSlides.length === 0) return;
      var videoSlides = allSlides.filter(isVideoSlide);
      var imageSlides = allSlides.filter(function (s) { return !isVideoSlide(s); });
      var slides = imageSlides.length ? imageSlides : allSlides;
      if (videoSlides.length > 0) {
        videoSlides.forEach(function (v) { v.style.display = 'none'; v.setAttribute('aria-hidden','true'); });
        var videoSection = document.createElement('section');
        videoSection.className = 'gs-pdp-videos';
        videoSection.setAttribute('aria-label', 'Produkt-Videos');
        videoSlides.forEach(function (vSlide) {
          var stage = document.createElement('div');
          stage.className = 'gs-pdp-videos__stage';
          var inner = document.createElement('div');
          inner.className = 'gs-pdp-videos__frame';
          var media = vSlide.querySelector('video, iframe, deferred-media');
          if (media) {
            if (media.tagName === 'VIDEO') {
              media.setAttribute('controls', '');
              media.setAttribute('playsinline', '');
              media.removeAttribute('autoplay');
              media.muted = true;
              media.style.width = '100%'; media.style.height = '100%'; media.style.objectFit = 'contain'; media.style.background = '#141414';
            }
            inner.appendChild(media.cloneNode(true));
          }
          stage.appendChild(inner);
          videoSection.appendChild(stage);
        });
        gallery.insertAdjacentElement('afterend', videoSection);
      }
      gallery.dataset.gsMounted = 'true';
      gallery.classList.add('gs-mounted');
      ['slideshow-component', 'slideshow-container', 'slideshow-slides'].forEach(function (tag) {
        gallery.querySelectorAll(tag).forEach(function (el) {
          el.style.display = 'block'; el.style.width = '100%'; el.style.position = 'relative'; el.style.gridTemplateColumns = 'none';
        });
      });
      gallery.style.width = '100%'; gallery.style.display = 'block';
      var active = 0;
      function setActive(idx, focusThumb) {
        active = ((idx % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('gs-active', i === active);
          if (i === active) { s.style.display = 'block'; s.style.width = '100%'; }
          else { s.style.display = 'none'; }
        });
        var dots = gallery.querySelectorAll('.gs-gallery-dot');
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
        if (dots[active]) dots[active].setAttribute('aria-current', 'true');
        dots.forEach(function (d, i) { if (i !== active) d.removeAttribute('aria-current'); });
        var thumbs = gallery.querySelectorAll('.gs-gallery-thumb');
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === active); });
        if (focusThumb && thumbs[active]) thumbs[active].focus();
      }
      function arrowSvg(dir) {
        return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (dir==='prev'?'M15 6l-6 6 6 6':'M9 6l6 6-6 6') + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
      function mkArrow(dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gs-gallery-arrow gs-gallery-arrow--' + dir;
        btn.setAttribute('aria-label', dir==='prev' ? 'Vorheriges Bild' : 'Naechstes Bild');
        btn.innerHTML = arrowSvg(dir);
        btn.addEventListener('click', function () { setActive(active + (dir==='next'?1:-1)); });
        return btn;
      }
      var slidesHost = slides[0].parentElement;
      slidesHost.style.position = 'relative';
      slidesHost.appendChild(mkArrow('prev'));
      slidesHost.appendChild(mkArrow('next'));
      var dotsUl = document.createElement('ul');
      dotsUl.className = 'gs-gallery-dots';
      dotsUl.setAttribute('role', 'tablist');
      slides.forEach(function (_, i) {
        var li = document.createElement('li');
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gs-gallery-dot' + (i===0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Bild ' + (i+1) + ' von ' + slides.length);
        dot.setAttribute('role', 'tab');
        dot.addEventListener('click', function () { setActive(i); });
        li.appendChild(dot); dotsUl.appendChild(li);
      });
      slidesHost.after(dotsUl);
      var thumbsUl = document.createElement('ul');
      thumbsUl.className = 'gs-gallery-thumbs';
      thumbsUl.setAttribute('role', 'tablist');
      slides.forEach(function (slide, i) {
        var li = document.createElement('li');
        var t = document.createElement('button');
        t.type = 'button';
        t.className = 'gs-gallery-thumb' + (i===0 ? ' is-active' : '');
        t.setAttribute('aria-label', 'Zu Bild ' + (i+1) + ' springen');
        t.setAttribute('role', 'tab');
        var srcImg = slide.querySelector('img');
        if (srcImg) {
          var img = document.createElement('img');
          img.src = srcImg.currentSrc || srcImg.src;
          img.alt = ''; img.loading = 'lazy';
          t.appendChild(img);
        }
        t.addEventListener('click', function () { setActive(i); });
        li.appendChild(t); thumbsUl.appendChild(li);
      });
      dotsUl.after(thumbsUl);
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); setActive(active - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setActive(active + 1, true); }
      });
      gallery.setAttribute('tabindex', '-1');
      var touchStartX = 0;
      slidesHost.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      slidesHost.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 50) setActive(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
      setActive(0);
    });
  }
  function run() {
    initGalleryCarousel();
    document.addEventListener('shopify:section:load', function () { setTimeout(initGalleryCarousel, 50); });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
